var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{directives:[{name:"scroll-reveal",rawName:"v-scroll-reveal",value:({ reset: false, opacity: 0 }),expression:"{ reset: false, opacity: 0 }"}],attrs:{"id":"inspire"}},[_c('Header'),_c('v-main',[_c('router-view')],1),_c('Footer'),_c('GoToTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }